import React from "react";
import { KeywordEntry } from "../../../views/convoauto-pages/bot-studio/types";

const TrashIcon = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-none stroke-gray-400 stroke-2">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6l-1 14H6L5 6" />
    <path d="M10 11v6M14 11v6" />
    <path d="M9 6V4h6v2" />
  </svg>
);

interface KeywordRowProps {
  entry: KeywordEntry;
  isFirst: boolean;
  maxChars: number;
  onChange: (updated: KeywordEntry) => void;
  onDelete?: () => void;
}

export const KeywordRow: React.FC<KeywordRowProps> = ({
  entry,
  isFirst,
  maxChars,
  onChange,
  onDelete,
}) => (
  <div className="mb-2">
    <div className="flex items-center gap-2">
      <input
        className="flex-1 border border-gray-200 rounded-lg px-3 py-2 text-sm text-gray-700 placeholder-gray-400 outline-none focus:ring-1 focus:ring-indigo-300 focus:border-indigo-300"
        placeholder="Enter Keyword"
        value={entry.text}
        maxLength={maxChars}
        onChange={(e) => onChange({ ...entry, text: e.target.value })}
      />
      {isFirst && (
        <div className="w-3 h-3 rounded-full bg-indigo-500 border-2 border-white shadow flex-shrink-0" />
      )}
      {!isFirst && onDelete && (
        <button onClick={onDelete} className="flex-shrink-0 hover:opacity-70 transition-opacity">
          <TrashIcon />
        </button>
      )}
    </div>

    <div className="flex items-center justify-between mt-1.5 px-0.5">
      <button
        onClick={() => onChange({ ...entry, match_similar: !entry.match_similar })}
        className="flex items-center gap-1.5 text-xs text-gray-500 select-none"
      >
        <span
          className={`relative inline-flex w-8 h-4 rounded-full transition-colors duration-200 ${entry.match_similar ? "bg-indigo-600" : "bg-gray-300"
            }`}
        >
          <span
            className={`absolute top-0.5 w-3 h-3 bg-white rounded-full shadow transition-transform duration-200 ${entry.match_similar ? "translate-x-4" : "translate-x-0.5"
              }`}
          />
        </span>
        Match Similar
      </button>
      <span className="text-xs text-[#7B7B7B] font-semibold">
        ({entry.text.length}/{maxChars})
      </span>
    </div>
  </div>
);